export default __webpack_public_path__ + "static/media/logo.15f1d389.png";